import { render, staticRenderFns } from "./PostRelationships.vue?vue&type=template&id=eed7f7e2&scoped=true"
import script from "./PostRelationships.vue?vue&type=script&lang=js"
export * from "./PostRelationships.vue?vue&type=script&lang=js"
import style0 from "./PostRelationships.vue?vue&type=style&index=0&id=eed7f7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed7f7e2",
  null
  
)

export default component.exports